import { isoAndUnixZodSchema } from "@@/shared/date-time/iso-and-unix";
import { priceZodSchema } from "@@/shared/prices/price";
import { z } from "zod";
import { payRequestReferencesZodSchema } from "../../events/_pay-request-references";
import { payRequestPaymentCancelledEventZodObject } from "../../events/pay-request.payment-cancelled.event";
import { payRequestPaymentExpiredEventZodObject } from "../../events/pay-request.payment-expired.event";
import { payRequestPaymentFailedEventZodObject } from "../../events/pay-request.payment-failed.event";
import { payRequestPaymentFulfilledEventZodObject } from "../../events/pay-request.payment-fulfilled.event";
import { payRequestPaymentInitiatedEventZodObject } from "../../events/pay-request.payment-initiated.event";
import { payRequestIdZodSchema } from "../../pay-request-id";
import { payRequestItemZodSchema } from "../../pay-request-item";
import { payRequestRecipientZodSchema } from "../../pay-request-recipient";

const payRequestForCheckoutProjectionZodObject = z.object({
    _id: payRequestIdZodSchema,
    _type: z.literal("PAY_REQUEST_FOR_CHECKOUT_PROJECTION"),
    _createdAt: isoAndUnixZodSchema,
    _version: z.number(),
    checkoutable: z.boolean(),
    /**
     * Contact info for payers of the pay request
     * a notification will (have) be(en) sent to these contacts
     */
    recipients: z.array(payRequestRecipientZodSchema).min(1),
    paymentInitiated: z.boolean(),
    paymentFulfilled: z.boolean(),
    /**
     * When someone initiates an attempt to pay the pay request,
     * payment events are created to follow the payment process(es)
     * E.g. the first attempt could fail, then the payer could try again
     * and more payment events would be created
     */
    paymentEvents: z.array(
        z.union([
            payRequestPaymentCancelledEventZodObject,
            payRequestPaymentFailedEventZodObject,
            payRequestPaymentFulfilledEventZodObject,
            payRequestPaymentExpiredEventZodObject,
            payRequestPaymentInitiatedEventZodObject,
        ]),
    ),
    /** Items to be paid using the pay request */
    items: z.array(payRequestItemZodSchema).min(1),
    /** Pay request amount */
    price: priceZodSchema,
    /**
     * An object with references to the order, order group, order events and provider that the
     * pay request is a payment for
     * */
    paymentFor: payRequestReferencesZodSchema,
});

type PayRequestForCheckoutProjection = z.infer<
    typeof payRequestForCheckoutProjectionZodObject
>;
const payRequestForCheckoutProjectionZodSchema: z.ZodSchema<PayRequestForCheckoutProjection> =
    payRequestForCheckoutProjectionZodObject;

export {
    payRequestForCheckoutProjectionZodObject,
    payRequestForCheckoutProjectionZodSchema,
};
export type { PayRequestForCheckoutProjection };
